import { render, staticRenderFns } from "./Presupuesto.vue?vue&type=template&id=e1cc86e6&scoped=true"
import script from "./Presupuesto.vue?vue&type=script&lang=js"
export * from "./Presupuesto.vue?vue&type=script&lang=js"
import style0 from "./Presupuesto.vue?vue&type=style&index=0&id=e1cc86e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cc86e6",
  null
  
)

export default component.exports